import axios from 'axios'

const requestBusinessObjects = ({
    token,
    headers = {},
    ...rest
}) => {
    const skymindApiURL = process.env.REACT_APP_SKYMIND_API

    return axios.request({
        ...rest,
        baseURL: `${skymindApiURL}/skycore-backend/v1/`,
        headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
        },
    })
}

export default requestBusinessObjects
